/**
 * @format
 * @Description: 我的消息状态机
 * @Autho: 方证
 * @Date: 2019/12/10
 */

import { action, observable, useStrict } from 'mobx';
import Serv from './MyMessageServ';

const CDN_BASE = 'assets';
useStrict(true);
class MyMessageMod {
  @observable
  editing = true;
  @observable
  tabsVal = '0';

  @action
  updateStore(payload) {
    for (let i in payload) {
      this[i] = payload[i];
    }
  }
  getSortNo(item) {
    let index = 0;
    if (item.children && item.children.length) {
      item.children.forEach(item1 => {
        item1.sortNO > index;
        index = item1.sortNO;
      });
    }
    return index + 1;
  }
  @action addOrganization = async payload => {
    // 请求参数
    let params = payload;

    return await Serv.addOrganization(params);
  };
}

// ES6单例写法
export default new MyMessageMod();



// WEBPACK FOOTER //
// ./src/pages/MessageManage/MyMessage/MyMessageMod.js